import React, { memo, useState } from 'react';
import cn from 'classnames';

import { HEADER_COLS, rowData } from './constants';
import css from './table.module.css';
import { TableCell } from './tableCell';
import { TableHeader } from './tableHeader';
import { THeader, TRow } from './types';

export const Table = memo(() => {
  const initialCols: THeader[] = localStorage.getItem('headerCols')
    ? JSON.parse(localStorage.getItem('headerCols') || '')
    : HEADER_COLS;

  const initialRows: TRow[] = localStorage.getItem('rowData')
    ? JSON.parse(localStorage.getItem('rowData') || '')
    : rowData;
  const [headerCols, setHeaderCols] = useState(initialCols);
  const [dataCells, setDataCells] = useState(initialRows);

  const handleName = (name?: string) => {
    setDataCells((prev) => {
      const rowIndex = prev.findIndex((item) => item.name === name);
      const newRows = [...prev];
      const newPlayer = { ...newRows[rowIndex] };

      newPlayer.isCrossed = !newPlayer.isCrossed;
      newRows[rowIndex] = newPlayer;
      // save to local storage
      localStorage.setItem('rowData', JSON.stringify(newRows));
      return newRows;
    });
  };
  console.log('dataCells', dataCells);
  return (
    <div className={css.root}>
      <table className={css.table}>
        <thead>
          <tr>
            {headerCols.map(({ field }, index) => (
              <TableHeader
                key={index}
                field={field}
                onChangeName={setHeaderCols}
              />
            ))}
          </tr>
        </thead>
        <tbody>
          {dataCells.map((row, i) => {
            if (row.title) {
              return (
                <tr key={i}>
                  <th className={cn(css.title)}>{row.title}</th>
                  {i === 0 && (
                    <>
                      {/* <th>
                        <input value={} />
                      </th> */}
                    </>
                  )}
                </tr>
              );
            }

            return (
              <tr key={i}>
                <td
                  className={cn(css.name, {
                    [css.longTitle]: (row.name || '')?.length > 15,
                    [css.crossed]: row.isCrossed,
                  })}
                  onClick={() => handleName(row.name)}
                >
                  {row.name}
                </td>
                {headerCols.map((_, index) => {
                  if (!index) return null;

                  return (
                    <TableCell
                      key={index}
                      playerIndex={index}
                      row={row}
                      onChangeCell={setDataCells}
                    />
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
});

Table.displayName = 'Table';
